import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import { useSelector } from 'react-redux';

import usePingListener from '@/hooks/usePingListener';
import useWaitingRobotTimer from '@/hooks/useWaitingRobotTimer';
import EventEmitter from '@/libs/EventEmitter';
import { isColdPosition } from '@/utils/MapUtils';

const useOrganizer = (robot) => {
  const robotStatus = useSelector((state) => state.robotStatus[robot.id]);

  usePingListener(robot.id);
  useWaitingRobotTimer(robot.id);

  useUpdateEffect(() => {
    const { lat, lon: lng } = robotStatus;

    // GPS 데이터 유효하지 않은 경우
    if (isColdPosition(lat, lng)) return;

    EventEmitter.publish('position/update', {
      robotId: robot.id,
      position: { lat, lng },
    });
  }, [robotStatus]);
};

export default useOrganizer;
